import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_66550cac from 'nuxt_plugin_plugin_66550cac' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_plugin_ebcb8af8 from 'nuxt_plugin_plugin_ebcb8af8' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_appinsightsclient_3009278a from 'nuxt_plugin_appinsightsclient_3009278a' // Source: ./appinsights.client.js (mode: 'client')
import nuxt_plugin_gtm_4a340a96 from 'nuxt_plugin_gtm_4a340a96' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_axios_231d5880 from 'nuxt_plugin_axios_231d5880' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_moment_23369450 from 'nuxt_plugin_moment_23369450' // Source: ./moment.js (mode: 'all')
import nuxt_plugin_datefilters_0e648352 from 'nuxt_plugin_datefilters_0e648352' // Source: ../plugins/date-filters (mode: 'all')
import nuxt_plugin_textresource_7fab38f8 from 'nuxt_plugin_textresource_7fab38f8' // Source: ../plugins/text-resource (mode: 'all')
import nuxt_plugin_vuepluralize_960957da from 'nuxt_plugin_vuepluralize_960957da' // Source: ../plugins/vue-pluralize (mode: 'all')
import nuxt_plugin_texteditor_2a57c8d7 from 'nuxt_plugin_texteditor_2a57c8d7' // Source: ../plugins/text-editor (mode: 'all')
import nuxt_plugin_authWrapper_13b95ed6 from 'nuxt_plugin_authWrapper_13b95ed6' // Source: ../plugins/authWrapper (mode: 'all')
import nuxt_plugin_authLogoutSync_5f596c03 from 'nuxt_plugin_authLogoutSync_5f596c03' // Source: ../plugins/authLogoutSync (mode: 'all')
import nuxt_plugin_hubspot_31993f41 from 'nuxt_plugin_hubspot_31993f41' // Source: ../plugins/hubspot (mode: 'all')
import nuxt_plugin_numberfilters_4265de6d from 'nuxt_plugin_numberfilters_4265de6d' // Source: ../plugins/number-filters (mode: 'all')
import nuxt_plugin_stringfilters_2d951b35 from 'nuxt_plugin_stringfilters_2d951b35' // Source: ../plugins/string-filters (mode: 'all')
import nuxt_plugin_sessionManager_115a052d from 'nuxt_plugin_sessionManager_115a052d' // Source: ../plugins/sessionManager (mode: 'all')
import nuxt_plugin_activityTracking_66653348 from 'nuxt_plugin_activityTracking_66653348' // Source: ../plugins/activityTracking (mode: 'all')
import nuxt_plugin_intercom_1516e49b from 'nuxt_plugin_intercom_1516e49b' // Source: ../plugins/intercom (mode: 'all')
import nuxt_plugin_pushtostatelistener_668fab05 from 'nuxt_plugin_pushtostatelistener_668fab05' // Source: ../plugins/push-to-state-listener (mode: 'all')
import nuxt_plugin_hotjar_607e9cb8 from 'nuxt_plugin_hotjar_607e9cb8' // Source: ../plugins/hotjar (mode: 'all')
import nuxt_plugin_clipboard2_0588d55c from 'nuxt_plugin_clipboard2_0588d55c' // Source: ../plugins/clipboard2 (mode: 'all')
import nuxt_plugin_vueemojipicker_35272c52 from 'nuxt_plugin_vueemojipicker_35272c52' // Source: ../plugins/vue-emoji-picker (mode: 'all')
import nuxt_plugin_userevents_4b65d425 from 'nuxt_plugin_userevents_4b65d425' // Source: ../plugins/user-events (mode: 'all')
import nuxt_plugin_console_1f861921 from 'nuxt_plugin_console_1f861921' // Source: ../plugins/console (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    return this.$root.$options.$nuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule
const baseStoreOptions = { preserveState: process.client }

function registerModule (path, rawModule, options = {}) {
  return originalRegisterModule.call(this, path, rawModule, { ...baseStoreOptions, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Mobiz | Hyper-Personalized Mobile Campaigns","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"Try our interactive demo and experience the power of personalized SMS marketing today!"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.png"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Caladea:ital,wght@0,400;0,700;1,400;1,700"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Spectral:ital,wght@0,400;0,700;1,400;1,700"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Noto+Colr+Emoji+Glyf"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Open+Sans:ital,wght@0,400;0,700;1,400;1,700"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Roboto+Mono:ital,wght@0,400;0,700;1,400;1,700"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Arimo:ital,wght@0,400;0,700;1,400;1,700"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Anonymous+Pro:ital,wght@0,400;0,700;1,400;1,700"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Nunito Sans:100,300,400,500,700,900&display=swap"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002F@mdi\u002Ffont@latest\u002Fcss\u002Fmaterialdesignicons.min.css"}],"script":[{"src":"https:\u002F\u002Fjs.chargebee.com\u002Fv2\u002Fchargebee.js","data-cb-site":"mobiz-us-test"},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function (w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e].p&&e[e][p]()))?1:0})(window,'navigator','doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-PHRXB9H')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-PHRXB9H&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_66550cac === 'function') {
    await nuxt_plugin_plugin_66550cac(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_ebcb8af8 === 'function') {
    await nuxt_plugin_plugin_ebcb8af8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_appinsightsclient_3009278a === 'function') {
    await nuxt_plugin_appinsightsclient_3009278a(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_4a340a96 === 'function') {
    await nuxt_plugin_gtm_4a340a96(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_231d5880 === 'function') {
    await nuxt_plugin_axios_231d5880(app.context, inject)
  }

  if (typeof nuxt_plugin_moment_23369450 === 'function') {
    await nuxt_plugin_moment_23369450(app.context, inject)
  }

  if (typeof nuxt_plugin_datefilters_0e648352 === 'function') {
    await nuxt_plugin_datefilters_0e648352(app.context, inject)
  }

  if (typeof nuxt_plugin_textresource_7fab38f8 === 'function') {
    await nuxt_plugin_textresource_7fab38f8(app.context, inject)
  }

  if (typeof nuxt_plugin_vuepluralize_960957da === 'function') {
    await nuxt_plugin_vuepluralize_960957da(app.context, inject)
  }

  if (typeof nuxt_plugin_texteditor_2a57c8d7 === 'function') {
    await nuxt_plugin_texteditor_2a57c8d7(app.context, inject)
  }

  if (typeof nuxt_plugin_authWrapper_13b95ed6 === 'function') {
    await nuxt_plugin_authWrapper_13b95ed6(app.context, inject)
  }

  if (typeof nuxt_plugin_authLogoutSync_5f596c03 === 'function') {
    await nuxt_plugin_authLogoutSync_5f596c03(app.context, inject)
  }

  if (typeof nuxt_plugin_hubspot_31993f41 === 'function') {
    await nuxt_plugin_hubspot_31993f41(app.context, inject)
  }

  if (typeof nuxt_plugin_numberfilters_4265de6d === 'function') {
    await nuxt_plugin_numberfilters_4265de6d(app.context, inject)
  }

  if (typeof nuxt_plugin_stringfilters_2d951b35 === 'function') {
    await nuxt_plugin_stringfilters_2d951b35(app.context, inject)
  }

  if (typeof nuxt_plugin_sessionManager_115a052d === 'function') {
    await nuxt_plugin_sessionManager_115a052d(app.context, inject)
  }

  if (typeof nuxt_plugin_activityTracking_66653348 === 'function') {
    await nuxt_plugin_activityTracking_66653348(app.context, inject)
  }

  if (typeof nuxt_plugin_intercom_1516e49b === 'function') {
    await nuxt_plugin_intercom_1516e49b(app.context, inject)
  }

  if (typeof nuxt_plugin_pushtostatelistener_668fab05 === 'function') {
    await nuxt_plugin_pushtostatelistener_668fab05(app.context, inject)
  }

  if (typeof nuxt_plugin_hotjar_607e9cb8 === 'function') {
    await nuxt_plugin_hotjar_607e9cb8(app.context, inject)
  }

  if (typeof nuxt_plugin_clipboard2_0588d55c === 'function') {
    await nuxt_plugin_clipboard2_0588d55c(app.context, inject)
  }

  if (typeof nuxt_plugin_vueemojipicker_35272c52 === 'function') {
    await nuxt_plugin_vueemojipicker_35272c52(app.context, inject)
  }

  if (typeof nuxt_plugin_userevents_4b65d425 === 'function') {
    await nuxt_plugin_userevents_4b65d425(app.context, inject)
  }

  if (typeof nuxt_plugin_console_1f861921 === 'function') {
    await nuxt_plugin_console_1f861921(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, (err) => {
        // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
        if (!err._isRouter) return reject(err)
        if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
